export default {
	TICKET_EXPIRED: 'TICKET_EXPIRED'
}
